export default __webpack_public_path__ + "static/media/best-place-to-retire.b717c8ec.jpg";